import { PropsWithChildren } from "react";
import { twMerge } from "tailwind-merge";

type Props = PropsWithChildren<{
  className?: string;
}>

const CardDefault = ({ children, className }: Props) => {
  return (
    <div className={twMerge('w-full flex flex-col gap-2 p-6 border-2 border-gray-200 rounded-lg', className)}>
      {children}
    </div>
  )
};

export default CardDefault;
